import axiosInstance from "../utils/axios"

export const institutionalTypeService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get('/institutional-type/all')
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/institutional-type',{ params })
    return response.data
  },
  findById: async (id) => {
    const response = await axiosInstance.get('/institutional-type/'+id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/institutional-type', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/institutional-type/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/institutional-type/${id}`)
    return response.data
  },
}
